import React from "react";

import { PolicyOverview } from "../../layouts/policyOverview/PolicyOverview";

const PolicyOverviewSitecore = (props) => <PolicyOverview fields={props.fields} />;

export default PolicyOverviewSitecore;
